module.exports = __webpack_public_path__ + "static/media/theend.453565e9.jpg";